export default __webpack_public_path__ + "static/media/X_Forms.49e41b9e.png";